@if(isV2){
<div class="tw-flex tw-items-center tw-bg-white tw-rounded-[0.25rem] tw-px-[0.5rem] sf-bg-1">
  <img [src]="CommonSVG.SEARCH_ICON" />

  <input type="text" placeholder="{{'ExdrCommon.Search' | translate}}" ngModel [(ngModel)]="searchText"
    (keyup)="onInputChange($event.target.value)" (ngModelChange)="onInputEmpty($event)"
    class="tw-w-[12.5rem] tw-h-[2rem] tw-border-none tw-outline-none tw-text-[0.875rem] tw-leading-none tw-font-normal tw-text-[#98A2B3]" />
  <mat-icon *ngIf="searchText && searchText.length" class="tw-cursor-pointer clear-btn-v2"
    (click)="clearSearch()">clear</mat-icon>
</div>
}@else{
<div class="txt-search-field-container" id="searchFieldContainer">
  <input [class.full-width]="isFullWidth" [style.background]="bgColor" type="text" class="txt-search-field"
    [style]="inputInlineStyle" [(ngModel)]="searchText" [placeholder]="'ExdrCommon.Search' |translate" ngModel
    (keyup)="onInputChange($event.target.value)" (ngModelChange)="onInputEmpty($event)">
  <mat-icon *ngIf="searchText && searchText.length" class="clear-btn pointer" (click)="clearSearch()">clear</mat-icon>
</div>
}